import { useMediaQuery } from "react-responsive"
import React, { useEffect, useState } from "react"
import FinancingDesktop from "./FinancingDesktop"
import FinancingMobile from "./FinancingMobile"

const Financing: React.FC = () => {
    const isDesktop = useMediaQuery({ minWidth: 1140 })
    const [isMounted, setIsMounted] = useState(false)

    useEffect(() => {
        setIsMounted(true)
    }, [])

    // Renderiza nulo até que o componente esteja montado para evitar problemas de hidratação
    if (!isMounted) {
        return null
    }

    return (
        <>
            { isDesktop ? <FinancingDesktop /> : <FinancingMobile /> }
        </>
    )
}

export default React.memo(Financing)
